module.exports = __webpack_public_path__ + "assets/b7c14a0a5d45cefe22c07e82ada503ab.mp3";